import { render, staticRenderFns } from "./ProdItem.vue?vue&type=template&id=2b22c018&scoped=true&"
import script from "./ProdItem.vue?vue&type=script&lang=js&"
export * from "./ProdItem.vue?vue&type=script&lang=js&"
import style0 from "./ProdItem.vue?vue&type=style&index=0&id=2b22c018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22c018",
  null
  
)

export default component.exports